
<template>
    <el-row class="main-box">
				<!--单词识记 -->
				<el-row v-if="step==0">
							<el-col :span="3" :offset="3" style="margin-right: 30px;">
								<div class="xcls flex-column " style="min-height: 146px;" > 
									<div class="tophead flex-row f-align-center">
										<img    :src="require('@/static/new_par_ic11.png')" />
										<span style="margin-left: 8px;">课程选择</span>
									</div>
									<el-select class="content-box2-select"   v-model="courseName" placeholder="请选择"
									@change="selectchange"
									>
									    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
									    </el-option>
									</el-select>
								</div>
								<div class="xcls flex-column " style="margin-top: 30px;" >
									<div class="tophead flex-row f-align-center">
										<img    :src="require('@/static/new_par_ic1.png')" />
										<span style="margin-left: 8px;">拼读技巧</span>
									</div>
									<div class="tophead_view1">
										<span v-html="data.description"></span>
									</div>
								</div>
							</el-col> 
							<el-col class="listdivcls1":span="11" >
								<div style="margin-top: 20px;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
									单词识记</div>
									
								<div style="margin-top: 8px;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #color: #409F70;">
									{{data.phonetic}}  </div>	
												
								<div  class="itembgcls1 flex-row f-align-center" v-for="(itemdata, indexdata) in preschooldata" :key="indexdata" @click="oneclick(itemdata)">
									<div 
									style="flex: 3;margin-left: 30px;text-align: start;color: #1A1A1A;
									font-size: 30px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
										<span  v-html="itemdata.wordNamecp"></span>
										</div>
										<img class="imagwh"  style="width: 60px;height: 60px;" mode="fill" :src="itemdata.imgUrl" />
										
										<el-tooltip effect="dark" :content="itemdata.chinese" placement="top-end">
										    <div
										    style="flex: 2;text-align: start;
										    margin-left: 26px;
										    color: #333333;
										    overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
										    font-size: 30px;">{{itemdata.chinese}}</div>
										</el-tooltip>
										
									</div>
									<div class="flex-row f-justify-end">
									<div class="xiayigcls" @click="nexclic2()">
										下一关
									</div>
									</div>
							</el-col>
							<!-- :span="2.5" -->
							<el-col  style="margin-left: 30px;width: 130px;"  >
								<div class="itembgcls2"  @mouseenter="pageMouseEnter($event)" @mouseleave="pageMouseLeave($event)" >
									<div  class="flex-cloumn f-align-center" v-for="(itemdata, indexdata) in maindata" :key="indexdata">
										<div :class="index==indexdata?'itembgclssele2':itemdata.isLearn==1?'itembgclssele1':'itembgclssele0'" @click="initdatcis(indexdata)">  
											{{itemdata.phonetic}}
											</div>
									</div>
								</div>
							</el-col>
				</el-row>
				
				
				<!--消消乐-->
				<el-row v-if="step==1">
							<el-col :span="3" :offset="3" style="margin-right: 30px;">
								<div class="xcls flex-column " style="min-height: 146px;" >
									<div class="tophead flex-row f-align-center">
										<img    :src="require('@/static/new_par_ic11.png')" />
										<span style="margin-left: 8px;">课程选择</span>
									</div>
									<div class="content-box2-select">
										<div style="margin-left: 20px;margin-right: 20px;overflow: hidden;">{{courseName}}</div>
									</div>
								</div>
								<div class="xcls flex-column " style="margin-top: 30px;" >
									<div class="tophead flex-row f-align-center">
										<img    :src="require('@/static/new_par_ic1.png')" />
										<span style="margin-left: 8px;">拼读技巧</span>
									</div>
									<div class="tophead_view1">
										<span v-html="data.description"></span>
									</div>
								</div>
							</el-col> 
							<el-col class="listdivcls2":span="11" >
								<div style="margin-top: 20px;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
									消消乐</div>
									
								<div style="margin-top: 8px;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #color: #409F70;">
									{{data.phonetic}}  </div>	
												
								<div  v-for="(itemdata, indexdata) in preschooldataxxl" :key="indexdata" >
										<transition     leave-active-class="animate__animated animate__bounceOutUp" :duration="{ enter: 200, leave: 600 }" mode="out-in">
									<div v-if="showindex2!=indexdata" class="itembgcls1 flex-row f-align-center">
									<div 
									@click="oneclick(itemdata)"
									style="flex: 3;;margin-left: 30px;text-align: start;color: #1A1A1A;
									font-size: 30px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
										<span v-if="showindex1!==indexdata" v-html="itemdata.wordNamecp"></span>
										<span v-else>{{itemdata.chinese}}</span>
										</div>
										<img class="imagwh"  style="width: 68px;height: 68px;" mode="fill" :src="itemdata.imgUrl" />
									<div class=" flex-row f-align-center f-justify-end" style="flex: 2;">
										<img class="imagwh"  style="margin-right: 25px;" mode="fill"  @click="remDataxxl(indexdata)"  :src="require('@/static/jd2_check3_1.png')"/>
									</div>
									</div>
									</transition>
									</div>
							</el-col>
				</el-row>
				
				<el-row v-if="step==2">
					<el-col class="listdivcls3 flex-column f-align-center"  :offset="7" :span="9" >
						<div style="margin-top: 20px;">
							消消乐
							 </div>
						<div class="bucls3" @click="click5next(0)" style="margin-top:36px ;">
								学习下一个
							</div>
						<div class="bucls4" @click="click5next(1)" style="margin-top:20px ;">
							混合全部
						</div>
					</el-col>
				</el-row>
				
				
				<!--混合消消乐-->
				<el-row v-if="step==3">
							<el-col class="listdivcls4":span="11" :offset="6" >
								<div style="margin-top: 20px;font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
									混合消消乐</div>
								<div  v-for="(itemdata, indexdata) in allpreschooldataxxl" :key="indexdata" >
										<div class="itembgcls1 flex-row f-align-center">
											<div class="flex1" 
											@click="oneclick(itemdata)"
											style="margin-left: 30px;text-align: start;color: #1A1A1A;
											font-size: 30px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
												<span v-if="showindex1!==indexdata" v-html="itemdata.wordNamecp"></span>
												<span v-else>{{itemdata.chinese}}</span>
												</div>
											<img class="imagwh" style="margin-left: 15px;margin-right: 30px;"  mode="fill"  @click="ramedata(indexdata)"  :src="require('@/static/jd2_check3_1.png')"/>
										</div>
									</div>
							</el-col>
				</el-row>
				
				<!--学后检测-->
				<el-row v-if="step==4" >
							<el-col class="listdivcls" :offset="7" :span="9">
								<div style="font-family: 思源黑体;font-size: 30px;font-weight: bold;line-height: normal;letter-spacing: 0em;color: #333333;">
									学后练习</div>
									<div  v-for="(itemdata, indexdata) in allafterdata" :key="indexdata" >
											<div class="itembgcls1 flex-row f-align-center">
												<div class="flex1" 
												@click="oneclick(itemdata)"
												style="margin-left: 30px;text-align: start;color: #1A1A1A;
												font-size: 30px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
													<span v-if="showindex1!==indexdata" v-html="itemdata.wordNamecp"></span>
													<span v-else>{{itemdata.chinese}}</span>
													</div>
												
												<img  class="imagwh" style="margin-right: 6px;" mode="fill" @click="addzq(indexdata)"  :src="itemdata.isGrasp==1? require('@/static/jd_check1_1.png'):require('@/static/jd_check1_0.png')"/>
													<img class="imagwh" style="margin-right: 26px;" mode="fill"  @click="addcw(indexdata)"  :src="itemdata.isGrasp==0?require('@/static/jd_check2_1.png'):require('@/static/jd_check2_0.png')"/>
											
												</div>
										</div>
							</el-col>
							<el-col :span="4">
								<div class="xcls flex-column "  style="position: fixed;width: 13%;margin-left: 30px"> 
									<div class="dccls flex-row f-center" style="margin-top: 20px;">
										<span class="text11">全部</span>
										<span class="text12" style="margin-left: 10px;margin-right: 5px;">{{allafterdata.length}}</span>
										<span class="text13">单词</span>
									</div>
									<div class="flex-row f-center" style="margin-top: 20px;">
										<span class="text14">正确</span>
										<span class="text16" style="color: #0AA26B;">{{zqnum}}</span>
										<div  class="text17" ></div>
										<span class="text15">待学</span>
										 <span class="text16" style="color: #F4CB22;">{{cwnum}}</span>
									</div>
									<div class="bucls1" @click="sumclick()" style="margin-top:21px ;">
										提交
									</div>
								<!-- 	<div class="bucls2" @click="finish()" style="margin-top:21px ;">
										返回
									</div> -->
								</div>
							</el-col>
				</el-row>
				
				<audio   ref="audio">
					<source :src="playsrc" type="audio/mp3"/>
				</audio>
		 </el-row>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { bottom } from '@popperjs/core';
export default {
    data() {
        return {
			playsrc:"",
			planId:"",
			recordId:"",
			courseId:"",
			studentId:"",
			step:0,//0 单词识记  1消消乐 2消消乐 下一步  3混合乐  4 学后练习
			maindata:[],
			data:{
				description:""
			},
			index:-1,
			preschooldata:[],//学前
			afterdata:[],//学后
			
			preschooldataxxl:[],//消消乐
			showindex1:-1,//消消乐动画指针
			showindex2:-1,//消消乐动画指针
			timer2: null,
			timer3: null,
					
			allpreschooldata:[],//学前
			allafterdata:[],//学后
			zqnum:0,
			cwnum:0,
			
			
			allpreschooldataxxl:[],//消消乐
			
			options: [{
			}],
					courseName:"",
			}
    },
    computed: {
      ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
    },
	created() {
		
		this.planId =  decodeURIComponent(this.$route.query.planId);
		this.courseId = decodeURIComponent(this.$route.query.courseId)
		this.studentId = decodeURIComponent(this.$route.query.studentId)
		// this.recordId = decodeURIComponent(this.$route.query.recordId)
		console.log("!~~~~"+this.planId);
		this.getdataCourseList();
	},
	beforeDestroy() {  
	     this.showclasstimer && clearInterval(this.showclasstimer)
	},
    methods: {
		selectchange(data){
			console.log("!!!~~~~"+data);
			this.index=-1;
			for(var item in this.options)
			{
				var itemdata= this.options[item];
				if(itemdata.name==data)
				{
					this.courseId=itemdata.id;
					break;
				}
			}
			this.initdatamain();
		},
		async getdataCourseList() {
		    let res = await this.$api.get("/web/phonics/phonicsStudentCourseList", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					studentId :this.studentId,
				 }
		    });
			if(res.code==200)
			{
				this.options=res.data;
				for(var j=0;j<this.options.length;j++)
				{
					if(this.courseId==this.options[j].id)
					{
						this.courseName=this.options[j].name;
						break;
					}
				}
					this.initdatamain();
			}},
		async sumclick(){
			var datalist=[];
			for(var i=0;i<this.allafterdata.length;i++)
			{
				datalist.push({
					    "chinese": this.allafterdata[i].chinese,
					    "id":  this.allafterdata[i].id,
						"isGrasp":this.allafterdata[i].isGrasp,
					    "phonetic":  this.allafterdata[i].phonetic,
					    "phoneticId": this.allafterdata[i].phoneticId,
					    "pronunciation":  this.allafterdata[i].pronunciation,
					    "word":  this.allafterdata[i].wordName
				});
			}
			
			// Loading.service();/prod-api/web/phonics/phoneticWordExerciseDataSubmit
			let res = await this.$api.post("/web/phonics/phoneticWordExerciseDataSubmit",{
				courseId:this.courseId,
				phoneticLearnWordDetailVos:datalist,
				planId:this.planId,
				recordId:this.recordId,
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.$message({
				  type: "success",
				  message: "提交成功"
				});
				this.$router.back();
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
		async phoneticWordLearnDataSubmit(){
			
			var datalist=[];
			for(var i=0;i<this.allpreschooldata.length;i++)
			{
				datalist.push({
					    "chinese": this.allpreschooldata[i].chinese,
					    "id":  this.allpreschooldata[i].id,
					    "phonetic":  this.allpreschooldata[i].phonetic,
					    "phoneticId": this.allpreschooldata[i].phoneticId,
					    "pronunciation":  this.allpreschooldata[i].pronunciation,
					    "word":  this.allpreschooldata[i].wordName
				});
			}
			let res = await this.$api.post("/web/phonics/phoneticWordLearnDataSubmit",{
				courseId:this.courseId,
				phoneticLearnWordDetailVos:datalist,
				planId:this.planId,
				recordId:this.recordId,
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
			if(res.code==200)
			{
				this.recordId=res.msg;
				//混合全部
				let currentIndex = this.allafterdata.length;
				while (0 !== currentIndex) {
				        let randomIndex = Math.floor(Math.random() * currentIndex);
				        currentIndex -= 1;
				        // 交换元素
				        let temp = this.allafterdata[currentIndex];
				        this.allafterdata[currentIndex] = this.allafterdata[randomIndex];
				        this.allafterdata[randomIndex] = temp;
				}
				this.step=4;
				// this.$message({
				//   type: "success",
				//   message: "提交成功"
				// });
				// this.$router.back();
			}else{
				this.$message({
				  type: "warning",
				  message: res.msg
				});
			}
		},
		addzq(index){
			if(this.allafterdata[index].isGrasp==1)
			{
				return;
			}
			
			if(this.allafterdata[index].isGrasp==0)
			{
				this.cwnum--;
			}
			this.allafterdata[index].isGrasp=1;
			this.zqnum++;
		},
		addcw(index){
			if(this.allafterdata[index].isGrasp==0)
			{
				return;
			}
			
			if(this.allafterdata[index].isGrasp==1)
			{
				this.zqnum--;
			}
			this.allafterdata[index].isGrasp=0;
			this.cwnum++;
		},
		ramedata(inde){
			if(this.allpreschooldataxxl.length>1)
			{
				this.allpreschooldataxxl.splice(inde,1);
			}else{
				this.phoneticWordLearnDataSubmit();
			}
		},
		click5next(type){
			if(type==0)
			{
				this.index=-1;
				//学习下一个
				for(var i=0;i<this.maindata.length;i++)
				{
					if(this.maindata[i].isLearn!=1){
						this.index=i;
					}
				}
				if(this.index!=-1)
				{
					this.initdatcis(this.index);
				}else{
					this.initdatcis(0);
				}
				

				this.step=0;
			}else{
				//混合全部
				this.allpreschooldataxxl= JSON.parse(JSON.stringify(this.allpreschooldata));
				let currentIndex = this.allpreschooldataxxl.length;
				while (0 !== currentIndex) {
				        let randomIndex = Math.floor(Math.random() * currentIndex);
				        currentIndex -= 1;
				        // 交换元素
				        let temp = this.allpreschooldataxxl[currentIndex];
				        this.allpreschooldataxxl[currentIndex] = this.allpreschooldataxxl[randomIndex];
				        this.allpreschooldataxxl[randomIndex] = temp;
				}
				this.step=3;
			}
		},
		
		nexclic2(){
			//第一步下一步
			this.preschooldataxxl= JSON.parse(JSON.stringify(this.preschooldata));
			let currentIndex = this.preschooldataxxl.length;
			while (0 !== currentIndex) {
			        let randomIndex = Math.floor(Math.random() * currentIndex);
			        currentIndex -= 1;
			        // 交换元素
			        let temp = this.preschooldataxxl[currentIndex];
			        this.preschooldataxxl[currentIndex] = this.preschooldataxxl[randomIndex];
			        this.preschooldataxxl[randomIndex] = temp;
			}
			this.step=1;
			this.data.isLearn=1;
		},
		remDataxxl(indexdata){
			if(this.showindex2!=-1)
			{
				return;
			}
			this.clearTimer1();
				this.showindex1=indexdata;
				var self=this;
				this.timer2 = setTimeout(() => {
						this.showindex2=this.showindex1;
						this.showindex1=-1;
						this.clearTimer3();
						this.timer3 = setTimeout(() => {
						 if(this.preschooldataxxl.length>1)
						 {
							this.preschooldataxxl.splice(this.showindex2,1);
						 }else{
							this.step=2;
							this.alladdreq();
						 }
						  this.showindex2=-1;
						 }, 600);
				 }, 500);
		},
		alladdreq(){
			//去重 并添加
			for(var i=0;i<this.preschooldata.length;i++){
				var isrc=false;
				for(var j=0;j<this.allpreschooldata.length;j++)
				{
					if(this.preschooldata[i].id==this.allpreschooldata[j].id)
					{
						isrc=true;
						break;
					}
				}
				if(!isrc)
				{
				this.allpreschooldata.push(this.preschooldata[i]);
				}
			}
			
			for(var i=0;i<this.afterdata.length;i++){
				var isrc=false;
				for(var j=0;j<this.allafterdata.length;j++)
				{
					if(this.afterdata[i].id==this.allafterdata[j].id)
					{
						isrc=true;
						break;
					}
				}
				if(!isrc)
				{
				this.allafterdata.push(this.afterdata[i]);
				}
			}
		},
		
		clearTimer1 () {
		    this.timer2 && clearInterval(this.timer2)
		 },
		 clearTimer3 () {
		     this.timer3 && clearInterval(this.timer3)
		  },
		oneclick(itemdata){
			this.play(itemdata.pronunciation);
		},
		async initdatamain(){
			let res = await this.$api.get("/web/phonics/workLearnList", {
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    },
				params:{
					planId :this.planId,
					courseId:this.courseId,
				 }
			});
			if(res.code==200)
			{
				this.maindata=res.data;
				for(var i=0;i<this.maindata.length;i++)
				{
					var content=this.maindata[i].description;
					const textToColor = this.maindata[i].keyword;
					if(content!=null)
					{
						var reg = "/"+textToColor+"/g";
						this.maindata[i].description=content.replace(eval(reg), `<span style="color: #0AA26B;">${textToColor}</span>`);
					}else{
						this.maindata[i].description="";
					}
					if(this.index==-1&&this.maindata[i].isLearn!=1){
						this.index=i;
					}
				}
				console.log("~！~~~"+this.index);
				if(this.index!=-1)
				{
					this.initdatcis(this.index);
				}else{
					this.initdatcis(0);
				}
			}
		},
		async initdatcis(index){
			this.index=index;
			this.data=this.maindata[index];
			
			this.preschooldata=[];
			this.afterdata=[];
			
			let res = await this.$api.get("/web/phonics/phoneticWordLearnList", {
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    },
				params:{
					phoneticId :this.data.id+"",
				 }
			});
			if(res.code==200)
			{
				var dcdata=res.data;
				for(var i=0;i<dcdata.length;i++)
				{
					
					var content=dcdata[i].wordName;
					if (dcdata[i].keywordIndex&&dcdata[i].keywordIndex.length>=10) {
							dcdata[i].wordNamecp=dcdata[i].keywordIndex;
					} else{
					const textToColor = this.data.keyword;
					var reg = "/"+textToColor+"/g";
					dcdata[i].wordNamecp=content.replace(eval(reg), `<span style="color: #0AA26B;">${textToColor}</span>`);
					}
					if(dcdata[i].type==1){
						this.preschooldata.push(dcdata[i]);
					}else{
						this.afterdata.push(dcdata[i]);
					}
				}
			}
		},
		
		// 鼠标移入显示 y轴 滚动条
		 pageMouseEnter(e) {
			 console.log("pageMouseEnter!!!!!~~~~");
		    e.target.style.overflowY = 'visible';
		},
		// 鼠标移出隐藏 y轴 滚动条
		 pageMouseLeave(e) {
			  console.log("pageMouseLeave!!!!!~~~~");
		    e.target.style.overflowY = 'hidden';
		},
		
		play(url)
		{
			this.playsrc=url;
			let music1 = new Audio();
			music1 = url;
		    this.$refs.audio.src = music1;
			let audioPlayer = this.$refs.audio;
			audioPlayer.playbackRate = 1.2;
			this.$refs.audio.play();
		},
    }
}
</script>
<style>
	/* 设置滚动栏的宽、高 */
	.itembgcls2::-webkit-scrollbar {
	    width: 8px;
	    height: 8px;
	}
	
	/* 设置滚动条的样式 */
	.itembgcls2::-webkit-scrollbar-thumb {
	    border-radius: 15px;
	    background-color: #eee;
	}
	
	/* 鼠标经过滚动条变换颜色 */
	.itembgcls2::-webkit-scrollbar-thumb:hover {
	    background-color: #CBCBFF;
	}
</style>

<style lang="scss" scoped>
	  @import '../../src/font.css';
.main-box {
    width: 100%;
	flex: 1;
    background: #B6E4D3;
    position: relative;
	padding-top: 84px;
	
	.listdivcls1{
	  min-height: 810px;
	  border-radius: 20px;
	  background: #E5F3F1;
	  font-family: Oswald;
	  font-size: 30px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  
	@media screen and (max-width: 1400px)  {
	 	  font-size: 25px;
	 }
	 
	 @media screen and (max-width: 1000px)  {
	  	  font-size: 18px;
	  }
	}
	.listdivcls2{
	  min-height: 750px;
	  border-radius: 20px;
	  background: #E5F3F1;
	  font-family: Oswald;
	  font-size: 30px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  
	@media screen and (max-width: 1400px)  {
	 	  font-size: 25px;
	 }
	 
	 @media screen and (max-width: 1000px)  {
	  	  font-size: 18px;
	  }
	}
	.listdivcls4{
	  min-height: 750px;
	  border-radius: 20px;
	  padding-bottom: 20px;
	  background: #E5F3F1;
	  font-family: Oswald;
	  font-size: 30px;
	  font-weight: normal;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  font-feature-settings: "kern" on;
	  /* 绿 */
	  color: #0AA26B;
	  
	  
	@media screen and (max-width: 1400px)  {
	 	  font-size: 25px;
	 }
	 
	 @media screen and (max-width: 1000px)  {
	  	  font-size: 18px;
	  }
	}
	
	.listdivcls3{
	 height: 236px;
	 border-radius: 20px;
	 opacity: 1;
	 
	 background: #E5F3F1;
	  font-family: 思源黑体;
	  font-size: 30px;
	  font-weight: bold;
	  line-height: normal;
	  text-align: center;
	  letter-spacing: 0em;
	  
	  font-feature-settings: "kern" on;
	  /* 333333 */
	  color: #333333;
	  
	@media screen and (max-width: 1400px)  {
	 	  font-size: 25px;
	 }
	 
	 @media screen and (max-width: 1000px)  {
	  	  font-size: 18px;
	  }
	}
	
	
	 .itembgcls1{
	 	cursor: pointer;
	 	/* 矩形 55 */
	 	margin-left: 30px;
	 	margin-right: 30px;
	 	margin-top: 28px;
	 	/* 纯白 */
		 height: 80px;
		 border-radius: 16px;
		 opacity: 1;
		 background: #FFFFFF;
		 box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);
	}
	
	.itembgcls2{
	 	cursor: pointer;
	 	height: 810px;
	 	border-radius: 20px;
	 	opacity: 1;
	 	background: #FFFFFF;
		 /* 内容溢出显示滚动条 */
		 overflow: scroll;
		  /* 隐藏x、y轴滚动条 */
		  overflow-y: hidden;
		  overflow-x: hidden;
	}
	
	
	
	.itembgclssele0{
		height: 64px;
		line-height: 64px;
		background: white;
		
		font-family: Oswald;
		font-size: 30px;
		font-weight: normal;
		text-align: center;
		letter-spacing: 0em;
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		color: #333333;
	}
	
	.itembgclssele1{
		height: 64px;
		background: rgba(165, 165, 165, 0.2);
			line-height: 64px;
		font-family: Oswald;
		font-size: 30px;
		font-weight: normal;
		text-align: center;
		letter-spacing: 0em;
		
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		color: #ACBEB0;
	}
	
	.itembgclssele2{
		height: 64px;
	background: rgba(10, 162, 107, 0.2);
			line-height: 64px;
		font-family: Oswald;
		font-size: 30px;
		font-weight: normal;
		text-align: center;
		letter-spacing: 0;
		
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		color: #0AA26B;
	}
	.xiayigcls{
		 cursor: pointer;
		width: 128px;
		height: 46px;
		border-radius: 40px;
		background: #0AA26B;font-family: 思源黑体;
		font-size: 18px;
		font-weight: bold;
		line-height: 46px;
		letter-spacing: 0em;
		font-feature-settings: "kern" on;
		/* 纯白 */
		color: #FFFFFF;
		margin-top: 50px;
		margin-right: 47px;
		margin-bottom: 10px;
	}

	
	.xcls{
		min-height: 320px;
		border-radius: 20px;
		opacity: 1;
		background: #FFFFFF;
		
		
		.tophead{
			height: 60px;
			padding-left: 23px;
			
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			img{
				width: 18px;
				height: 22px;
			}
		}
		
		.tophead_view1{
			border-radius: 20px;
			margin-left: 20px;
			margin-right: 20px;
			padding-top: 11px;
			padding-bottom: 20px;
			padding-left: 20px;
			padding-right: 20px;
			background: linear-gradient(334deg, #FFFFFF 13%, #D9F1E5 85%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
		}
		
		
		.content-box2-select {
		    // width: 210px;
			margin-left: 20px;
			margin-right: 20px;
		    height: 64px;
		    border-radius: 10px;
		    opacity: 1;
		
		    box-sizing: border-box;
		    border: 1px solid rgba(10, 162, 107, 0.2);
		    display: flex;
		    align-items: center;

		}
		
		.dccls{
			margin-left: 15px;
			margin-right: 15px;
			height: 76px;
			border-radius: 20px;
			opacity: 1;
			background: linear-gradient(330deg, #FFFFFF 14%, #D9F1E5 77%);
			box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
	
		}
		
		.text11{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 已选择 */
			font-family: 思源黑体;
			font-weight: 400;
			font-size: 18;
			color: #ACBEB0;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text12{
			font-family: Oswald;
			font-size: 36px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 20px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 10px;
			  }
		}
		
		.text13{
			font-weight: normal;
			line-height: 30px;
			letter-spacing: 0em;
			font-family: Source Han Sans;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		
		.text14{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text15{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 红 */
			color: #F4CB22;
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
			  }
		}
		
		.text16{
			font-family: Source Han Sans;
			font-size: 18px;
			font-weight: normal;
			line-height: normal;
			letter-spacing: 0em;
			margin-left: 19px;
			font-feature-settings: "kern" on;
		
			
			@media screen and (max-width: 1400px)  {
			 	  font-size: 15px;
				  margin-left: 10px;
			 }
			 
			 @media screen and (max-width: 1000px)  {
			  	  font-size: 8px;
				  margin-left: 8px;
			  }
		}
		
		
		.text17{
			width: 10%;
			
		
		}
		.bucls1{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			text-align: center;
			/* 绿 */
			background: #0AA26B;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: bold;
			line-height: 46px;
			letter-spacing: 0em;
			font-feature-settings: "kern" on;
			/* 纯白 */
			color: #FFFFFF;
		}
		
		.bucls2{
			margin-left: 15px;
			margin-right: 15px;
			 cursor: pointer;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			
			box-sizing: border-box;
			/* 绿 */
			border: 2px solid #0AA26B;
			text-align: center;
			font-family: 思源黑体;
			font-size: 18px;
			font-weight: normal;
			line-height: 46px;
			letter-spacing: 0em;
			
			font-feature-settings: "kern" on;
			/* 绿 */
			color: #0AA26B;
		}
		
		
	
		
	}
	
	.bucls3{
			cursor: pointer;
			width: 210px;
			height: 46px;
			border-radius: 100px;
			opacity: 1;
			/* 绿 */
			background: #0AA26B;
			color: #FFFFFF;
			font-size: 18px;
			font-weight: bold;
			text-align: center;
			line-height: 46px;
		}
		
		
		.bucls4{
			cursor: pointer;
			width: 210px;
			height: 46px;
			border-radius: 100px;
			text-align: center;
			line-height: 46px;
			opacity: 1;
			/* 绿 */
			background: #FFAA33;
			color: #FFFFFF;
			font-size: 18px;
			font-weight: bold;
		}
	.imagwh{
			width: 35px;
			height: 35px;
			
			 @media screen and (max-width: 1400px)  {
				width: 25px;
				height: 25px;
			}
			
			@media screen and (max-width: 1000px)  {
				width: 10px;
				height: 10px;
			}
		}
		
		.listdivcls{
		  border-radius: 20px;
		  background: #E5F3F1;
		  padding-top: 21px;
		  padding-bottom: 21px;
		  font-family: Oswald;
		  font-size: 30px;
		  font-weight: normal;
		  line-height: normal;
		  text-align: center;
		  letter-spacing: 0em;
		  font-feature-settings: "kern" on;
		  /* 绿 */
		  color: #0AA26B;
		  
		  
		@media screen and (max-width: 1400px)  {
		 	  font-size: 25px;
		 }
		 
		 @media screen and (max-width: 1000px)  {
		  	  font-size: 18px;
		  }
		}
		
		/deep/ .el-input__inner {
		    border: 0;
		    font-family: 思源黑体;
		    font-size: 18px;
		    font-weight: normal;
		    line-height: normal;
		    letter-spacing: 0em;
		
		    font-feature-settings: "kern" on;
		    /* 333333 */
		    color: #333333;
		}
		
}
</style>